import { useTranslation } from 'react-i18next'
import "./style.css"

const PrintCard = ({ name, value, className = "" }) => {
    const { t } = useTranslation()
    return (
        <div className={`print-card ${className}`}>
            <div className='print-card-header'>
                <p className="card-name">
                    {t(name)}:
                </p>
                <p className="card-value">
                    {value}
                </p>
            </div>
        </div>
    )
}

export default PrintCard